import React, { Component } from 'react';
import { Container } from '../index';

/**
 * Error boundary catches errors anywhere in their child component tree,
 * log those errors, and display a fallback UI instead of the component tree that crashed.
 *
 * Use ErrorBoundary to prevent White Screen Of Death (WSOD).
 *
 * Example:
 *
 * <ErrorBoundary>
 *   <Widget />
 * </ErrorBoundary>
 */
export class ErrorBoundary extends Component<{ children?: React.ReactNode }> {
  // initial state
  state = {
    error: null,
  } as { error: string | null };

  static getDerivedStateFromError(error) {
    // Update state so next render shows fallback UI.
    return { error: error };
  }

  componentDidCatch(error, info) {
    console.log(this);
    // log error messages
    console.log('ErrorBoundary: ', error.toString(), info?.componentStack);
  }

  render() {
    const { error } = this.state;
    if (error) {
      // Error path
      return (
        <Container>
          <h2>Something went wrong.</h2>
          <details>
            <summary>Error Summary</summary>
            <p>{error.toString()}</p>
          </details>
        </Container>
      );
    }
    // Normally, just render children
    return this.props.children;
  }
}
